import { v4 as generateUuid } from 'uuid'

import { EmbroideryItem, EmbroideryItemDraft, EmbroideryItemSource } from './types'

/**
 * Mints a selected item, giving it the id that addresses it for the rest of its life. Two items can
 * match in every other field, so nothing else can identify one.
 *
 * Items start enabled for the bag; unchecking one on the PDP is what turns that off.
 */
export const makeEmbroideryItem = (
  draft: EmbroideryItemDraft,
  source: EmbroideryItemSource
): EmbroideryItem => ({
  instanceId: generateUuid(),
  source,
  enabledForBag: true,
  ...draft,
})
